import React from 'react';
import { useHistory } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuButton from '@/components/common/MenuButton';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import { useCurrentUser } from '@/lib/hooks/userData';
import translate from '@/lib/intl/translate';
import { CommsResponsePropType, deleteComm } from '@/modules/Comms';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { Dialogs, useDialogManager } from '@/modules/Dialogs';

const ID = 'email-interaction-menu';

type EmailIntegrationMenuProps = {
  email: unknown;
};

export default function EmailIntegrationMenu({
  email,
}: EmailIntegrationMenuProps) {
  const history = useHistory();
  // @ts-expect-error TS(2554) TODO(ts-migrate): Expected 0 arguments, but got 1.
  const { isOrgAdmin, isOrgEditor } = useCurrentUser(true);
  const ownerOrgId = useOwnerOrgId();
  const { openDialog, closeDialog } = useDialogManager();
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
  const openMenu = (e: any) => setMenuAnchor(e.currentTarget);
  const closeMenu = () => setMenuAnchor(null);

  const openDeleteConfirmation = React.useCallback(() => {
    openDialog(Dialogs.CONFIRMATION, {
      children: (
        <div className="flex flex-col gap-y-4 text-base font-normal">
          {translate('DELETE_INTERACTION_LABEL')}
        </div>
      ),
      confirmLabel: translate('DELETE'),
      headerText: translate('DELETE_INTERACTION_TITLE'),
      onCancel: closeDialog,
      onClose: closeDialog,
      onConfirm() {
        try {
          // @ts-expect-error TS(2571) TODO(ts-migrate): Object is of type 'unknown'.
          deleteComm(email.commsId, ownerOrgId);
          closeDialog();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error);
        } finally {
          history.goBack();
        }
      },
    });
  }, []);

  const handleDeleteClick = () => {
    openDeleteConfirmation();
    setMenuAnchor(null);
  };

  if (!(isOrgAdmin || isOrgEditor)) {
    return null;
  }

  return (
    <>
      <MenuButton
        onClick={openMenu}
        className="ml-4 text-text-secondary"
        aria-controls={menuAnchor ? ID : undefined}
        aria-haspopup="true"
        data-testid="email-interation-details-menu"
      />
      <Menu
        id={ID}
        onClose={closeMenu}
        open={!!menuAnchor}
        anchorEl={menuAnchor}
      >
        <MenuItem
          onClick={handleDeleteClick}
          data-testid="email-interation-delete-menu-item"
        >
          {translate('DELETE')}
        </MenuItem>
      </Menu>
    </>
  );
}

EmailIntegrationMenu.propTypes = {
  email: CommsResponsePropType.isRequired,
};
